import { VeganTag, VegetarianTag, Under600CaloriesTag } from '@icons/dietary';

export const dietaryIconsMap = {
  vegetarian: VegetarianTag,
  vegan: VeganTag,
  under600kCal: Under600CaloriesTag,
};

export default dietaryIconsMap;
